module.exports = __webpack_public_path__ + "img/ss5.66843d47.jpg";